import { PUBLIC_SECTION_SURFACES } from './publicSectionSurfaces';
import { PublicSectionWaveBottom, PublicSectionWaveTop } from './PublicSectionWave';

/** Programme : transition surface (À propos) → rouge, puis rouge → gris (Filières). */
export function PublicProgrammeWaveTop() {
  return <PublicSectionWaveTop fill={PUBLIC_SECTION_SURFACES.aboutEnd} animated />;
}

export function PublicProgrammeWaveBottom() {
  return <PublicSectionWaveBottom fill={PUBLIC_SECTION_SURFACES.filieres} animated />;
}
